<div class="post-details-container" [ngClass]="{'mobile-view': isMobileScreen}">
  <div class="post-card parent-card">
    <div class="post-card-header">
      <div class="post-card-header-image" (click)="openUserDetailsDialog(post)" (keypress)="openUserDetailsDialog(post)">
        <span class="cursor-pointer">
          <!-- <img [src]="post.profilePictureUrl" alt="user icon" class="user-img" /> -->
          <app-user-thumb-nail [userEmail]="post.createdByName" class="user-img"></app-user-thumb-nail>
        </span>
      </div>
      <div class="post-card-header-data">
        <div class="user-name" (click)="openUserDetailsDialog(post)" (keypress)="openUserDetailsDialog(post)">
          <span class="user-name-details">{{ post.createdByName }}</span>
          <!-- createdByName should be changed below -->
          <small>{{ post.createdByName }}</small>
        </div>
        <small class="post-date">{{ post.modifiedAt + "Z" | date : "short" }}
          @if (post.createdAt !== post.modifiedAt) {
            <span>Edited</span>
          }</small>
        </div>
        <div class="post-card-header-actions">
          @if (
            !this.isPostDetailView ||
            (this.isPostDetailView && post.createdById == loggedInUser.id)
            ) {
            <span [matMenuTriggerFor]="actionsMenu" (click)="openActions(post)" (keypress)="openActions(post)" class="hover-black" overlapTrigger="true"
              >
              <img [src]="'images/more.svg' | assetUrl" alt="pin icon" />
            </span>
          }
          <mat-menu #actionsMenu="matMenu" class="actions-menu" xPosition="before">
            @for (item of menuList; track item) {
              <button class="mat-menu-item-button" mat-menu-item (click)="actionMenu(item.name, post)"
                [ngClass]="{ 'action-border-botton': item?.name === 'Details' }">
                @if (item?.icon) {
                  <mat-icon [class]="item.menuItemClasses">{{
                    item.icon
                  }}</mat-icon>
                }
                @if (item?.imgUrl) {
                  <img [src]="'images/' + item.imgUrl + '.svg' | assetUrl" alt="{{ item.imgUrl }} icon"
                    class="icon-mr-5" [class]="item.menuItemClasses" />
                }
                {{ item?.name }}
              </button>
            }
          </mat-menu>
        </div>
      </div>

      <div class="post-card-content">
        <p class="rte-content" [innerHTML]="post.messageToDisplay"></p>
      </div>

      <div class="post-card-footer">
        <span (click)="likePostOrCommentFunction(post)" (keypress)="likePostOrCommentFunction(post)" class="cursor-pointer pad">
        <img [src]="
            (post.like ? 'images/like.svg' : 'images/like_outline.svg')
              | assetUrl
          " alt="like icon" />
          </span>
          <span (click)="commentFunction(post)" class="cursor-pointer pad">
        <img [src]="
            (post.numberOfComments > 0
              ? 'images/comment.svg'
              : 'images/comment_outline.svg'
            ) | assetUrl
          " alt="send icon" />
            </span>
            <div class="likes-comments">
              @if (post.numberOfLikes > 0) {
                <span class="cursor-pointer pad" (click)="openLikedUsersDialog(post, true)" (keypress)="openLikedUsersDialog(post, true)">{{
                  post.numberOfLikes }}
                {{ post.numberOfLikes === 1 ? "like" : "likes" }}</span>
              }
              @if (post.numberOfComments > 0) {
                <span class="cursor-pointer pad"
                  (click)="post.openCommentBox = !post.openCommentBox" (keypress)="post.openCommentBox = !post.openCommentBox">{{ post.numberOfComments }}
                {{ post.numberOfComments === 1 ? "comment" : "comments" }}</span>
              }
            </div>
          </div>

          @if(post.openCommentBox) {
            @if (post?.comments?.length) {
              <div class="child-card-divider"></div>
            }
            @for (
              comment of post.comments; track trackItemByCommentId(j,
              comment); let j = $index) {
              <div class="post-card child-card">
                <div class="post-card-header child-header">
                  <div class="post-card-header-image child-header-image" (click)="openUserDetailsDialog(comment)" (keypress)="openUserDetailsDialog(comment)">
                    <span class="cursor-pointer">
                      <!-- <img [src]="comment.profilePictureUrl" alt="user icon" class="user-img" /> -->
                      <app-user-thumb-nail [userEmail]="comment.createdByName" class="user-img"></app-user-thumb-nail>
                    </span>
                  </div>
                  <div class="post-card-header-data" [ngStyle]="{'gap': isIhubScreen ? '6px' : ''}">
                    <div class="user-name" (click)="openUserDetailsDialog(comment)" (keypress)="openUserDetailsDialog(comment)">
                      <small class="user-name-details">{{ comment.createdByName }}</small>
                      <!-- <small>{{post.user.atMention}}</small> -->
                    </div>
                    <div class="child-content">
                      <small>
                        <p class="rte-content" [innerHTML]="comment.messageToDisplay"></p>
                      </small>
                    </div>
                    <div class="child-comment-like">
                      <small class="post-date">{{ comment.modifiedAt + "Z" | date : "short" }}
                        @if (comment.createdAt !== comment.modifiedAt) {
                          <span>Edited</span>
                        }</small>
                        <span (click)="likePostOrCommentFunction(comment, 'comment')" (keypress)="likePostOrCommentFunction(comment, 'comment')" class="cursor-pointer like-comment">
              <img [src]="
                  (comment.like ? 'images/like.svg' : 'images/like_outline.svg')
                    | assetUrl
                " alt="like icon" />
                          </span>
                          @if (comment.numberOfLikes > 0) {
                            <span class="cursor-pointer pad comment-like-count"
                              (click)="openLikedUsersDialog(comment, false)" (keypress)="openLikedUsersDialog(comment, false)">{{ comment.numberOfLikes }}
                            {{ comment.numberOfLikes === 1 ? "like" : "likes" }}</span>
                          }
                        </div>
                      </div>
                      @if (comment.createdById == this.loggedInUser.id) {
                        <div class="post-card-header-actions">
                          @if (
                            !(
                            comment.createdById == post.createdById &&
                            comment.createdById != loggedInUser.id
                            )
                            ) {
                            <span [matMenuTriggerFor]="commentActionsMenu" (click)="openCommentActions(comment)" (keypress)="openCommentActions(comment)" class="hover-black"
                              overlapTrigger="true">
                              <img [src]="'images/more.svg' | assetUrl" alt="pin icon" />
                            </span>
                          }
                          <mat-menu #commentActionsMenu="matMenu" class="actions-menu" xPosition="before">
                            @for (item of commentMenuList; track item) {
                              <button class="mat-menu-item-button" mat-menu-item (click)="commentActionMenu(item.name, comment, post)"
                                [ngClass]="{ 'action-border-botton': item?.name === 'Details' }">
                                @if (item?.imgUrl) {
                                  <img [src]="'images/' + item.imgUrl + '.svg' | assetUrl"
                                    alt="{{ item.imgUrl }} icon" [class]="item.menuItemClasses" />
                                }
                                {{ item?.name }}
                              </button>
                            }
                          </mat-menu>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="comments">
                  <exp-quill-rte [postDetails]="post" placeHolder="Your comment..." (updateValueChange)="addComment($event, post)"></exp-quill-rte>
                </div>
              }
            </div>
          </div>

          <collaboration-ui-doc-viewer [document]="previewElement" [isMobileScreen]="isMobileScreen"
            (onPreviewClose)="onPreviewClose()">
          </collaboration-ui-doc-viewer>
          @if (isPostDetailView && showLoader) {
            <collaboration-ui-spinner
            [overlay]="true"></collaboration-ui-spinner>
          }